export default "__VITE_ASSET__UrXVlWQl__"